import { DatePipe } from '@angular/common'
import { HttpEvent, HttpEventType } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { $app } from '../../app.service'
import { AppProject } from '../models/interfaces/app-project.interface'

@Injectable({ providedIn: 'root' })
export class AppFileDownloadService {
   constructor(private date: DatePipe) {}

   save(response: HttpEvent<Blob>, fileNamePrefix: string): void {
      if (response.type !== HttpEventType.Response || !response.body) return

      const fileName = fileNamePrefix + '_' + this.date.transform(new Date(), 'YYYYMMdd')
      $app.saveFile(fileName, response.body)
   }

   saveProject(response: HttpEvent<Blob>, project?: AppProject | null): void {
      let acronym: string | null = null

      if (project?.acronym) {
         acronym = project.acronym
            .toUpperCase()
            .trim()
            .replace(/[^A-Z]/g, '')
      }

      this.save(response, 'PMP_Project_' + (acronym || project?.id))
   }
}
